import React from 'react'
import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'

interface ComponentProps {
	children: any
}

function getLibrary(provider:any): any {
	return new Web3Provider(provider)
}

export const Web3AuthProvider:React.FC<ComponentProps> = ({ children }) => (
	<Web3ReactProvider getLibrary={getLibrary}>
		{children}
	</Web3ReactProvider>

)
